import React from 'react'

import { ElemyLogo } from '@ui/blocks/ElemyLogo'

import {
  Copyright,
  FooterBottom,
  FooterTop,
  FormContainer,
  FormHeading,
  LegalLink,
  LegalLinks,
  LogoContainer,
  SocialIcon,
  SocialItem,
  SocialLink,
  SocialLinks,
  StyledContainer,
  StyledFooter,
  StyledMenu,
  StyledZipCodeForm
} from './styles'
import { legalLinks, socials } from './data'

const Footer = () => {
  const currentYear = new Date()?.getFullYear()
  return (
    <StyledFooter>
      <StyledContainer>
        <FooterTop>
          <LogoContainer>
            <ElemyLogo color="white" />
          </LogoContainer>
          <StyledMenu />
          <FormContainer>
            <FormHeading>In-Home Autism Care</FormHeading>
            <StyledZipCodeForm variant="deepSea" placement="footer" />
            <SocialLinks>
              {socials.map(({ id, imageSrc, url, title }) => {
                return (
                  <SocialItem key={id}>
                    <SocialLink href={url} target="_blank" rel="noreferrer nofollow noopener">
                      <SocialIcon src={imageSrc} alt={title} />
                    </SocialLink>
                  </SocialItem>
                )
              })}
            </SocialLinks>
          </FormContainer>
        </FooterTop>
        <FooterBottom>
          <Copyright fontSize="1.2rem" lineHeight="3.7rem" color="textLinkGreen">
            © Copyright 2020 – {currentYear} Elemy.
          </Copyright>
          <LegalLinks>
            {legalLinks.map(({ id, title, url }) => {
              return (
                <LegalLink key={id} to={url}>
                  {title}
                </LegalLink>
              )
            })}
          </LegalLinks>
          <SocialLinks>
            {socials.map(({ id, imageSrc, url, title }) => {
              return (
                <SocialItem key={id}>
                  <SocialLink href={url} target="_blank" rel="noreferrer nofollow noopener">
                    <SocialIcon src={imageSrc} alt={title} />
                  </SocialLink>
                </SocialItem>
              )
            })}
          </SocialLinks>
        </FooterBottom>
      </StyledContainer>
    </StyledFooter>
  )
}

export default Footer
